import dayjs from "dayjs"
import { GGNLocations } from "../../interfaces/intakes.reports"
import { LuTrash2 } from "react-icons/lu";
import { SpinnerCustom } from "../ui/SpinnerCustom";
import { useState } from "react";
import { ModalConfirmation } from "../ui/ModalConfirmation";


interface Props {
    location: GGNLocations
    handleDeleteGGN: (ggn_number: string) => void
    isLoading?: boolean
    isFull?: boolean
}
export const GGNSingleWeather = ({ location, handleDeleteGGN, isLoading, isFull = false }: Props) => {

    const [confirmation, setConfirmation] = useState<boolean>(false)

    return (
        <div className="tw-py-4 tw-border-b tw-border-gray-200">

            {
                confirmation &&
                <ModalConfirmation
                    action={() => handleDeleteGGN(location.ggn_number)}
                    closeConfirmation={() => setConfirmation(false)}
                    buttonName="Remove Location"
                    msg="Are you sure you want to remove this location?"
                    isLoading={isLoading}
                />
            }

            <div className="tw-flex tw-justify-between tw-gap-2 tw-mb-2">
                <p className="tw-font-bold">{location.city} / <span className="tw-text-xs tw-text-neutral-400">{location.country}</span></p>
                {
                    isLoading
                        ? <SpinnerCustom color="blue" />
                        // : <button onClick={() => handleDeleteGGN(location.ggn_number)}>
                        : <button onClick={() => setConfirmation(true)}>
                            <LuTrash2 size={16} />
                        </button>
                }
            </div>

            <div className={`tw-grid ${isFull ? 'tw-grid-cols-7' : 'tw-grid-cols-4'} tw-gap-x-2 tw-gap-y-4`}>
                {
                    location.historical?.map((historical, index) => (
                        <div key={index} className="tw-grid tw-grid-cols-1">
                            <div className="tw-flex tw-flex-col sm:tw-flex-row tw-items-center sm:tw-items-start sm:tw-gap-2 tw-mb-2">
                                <img src={`/assets/weather/${historical.icon}`} className="tw-w-8 tw-aspect-square" />
                                <div>
                                    <p className="tw-text-xs tw-font-bold">{dayjs(historical.date).format('DD MMM')}</p>
                                    <p className="tw-text-xs tw-font-bold">{historical.min_temperature}° / {historical.max_temperature}°</p>
                                </div>
                            </div>
                            <div>
                                <div className="tw-flex tw-gap-1">
                                    <img src={`/assets/weather/humidity.jpg`} className="tw-object-contain tw-h-3 tw-aspect-square" />
                                    <p className="tw-text-xs">{historical.humidity} <span className="tw-text-[.6rem]">%</span></p>
                                </div>
                                <div className="tw-flex tw-gap-1">
                                    <img src={`/assets/weather/wind.jpg`} className="tw-object-contain tw-h-3 tw-aspect-square" />
                                    <p className="tw-text-xs">{historical.wind_speed} <span className="tw-text-[.6rem]">km/h</span></p>
                                </div>
                                <div className="tw-flex tw-gap-1">
                                    <img src={`/assets/weather/precipitation.jpg`} className="tw-object-contain tw-h-3 tw-aspect-square" />
                                    <p className="tw-text-xs">{historical.precipitation} <span className="tw-text-[.6rem]">mm</span></p>
                                </div>
                                <div className="tw-flex tw-gap-1">
                                    <img src={`/assets/weather/radiation.jpg`} className="tw-object-contain tw-h-3 tw-aspect-square" />
                                    <p className="tw-text-xs">{historical.solar_radiation} <span className="tw-text-[.6rem]">W/m²</span></p>
                                </div>
                            </div>
                        </div>
                    ))
                }

            </div>
        </div>
    )
}
